import React from "react";
import { Dropdown } from "react-bootstrap";

const InvoiceRow = ({
  invoice,
  STATUS_LABELS,
  toISODateOnly,
  handleViewInvoice,
  handleEditInvoice,
  handleDeleteInvoice,
  handleDownloadInvoice,
  downloadingInvoiceId,
  deleteLoading,
}) => {
  const rawStatus = invoice.status ?? invoice.invoice_status ?? 0;
  const invStatus = Number(rawStatus);
  const canEditOrDelete = String(invStatus) === "0";
  const statusLabel = STATUS_LABELS?.[invStatus] ?? String(rawStatus ?? "");
  const isApproved = invStatus === 2;

  const invoiceId = invoice.id || invoice.invoice_id;

  const formatCurrency = (value) =>
    "$" +
    Number(value ?? 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const paymentLabel =
    invoice.xero_status === 1 && invoice.paid_full === 1
      ? "Paid"
      : invoice.xero_status === 1 && invoice.paid_full === 0
      ? "Partially Paid"
      : "Pending";

  return (
    <tr>
      <td>
        <span
          role="button"
          onClick={() => handleViewInvoice(invoice)}
          style={{ cursor: "pointer", color: "inherit" }}
        >
          {invoice.xero_no || "Pending"}
        </span>
      </td>

      <td>
        <span
          role="button"
          onClick={() => handleViewInvoice(invoice)}
          style={{ cursor: "pointer", color: "inherit" }}
        >
          {invoice.invoice_title || ""}
        </span>
      </td>

      <td>
        {toISODateOnly(invoice.invoice_date || invoice.invoiceDate)}
      </td>

      <td>{toISODateOnly(invoice.due_date || invoice.dueDate)}</td>

      <td>{statusLabel}</td>

      <td>{formatCurrency(invoice.amount)}</td>

      <td>{formatCurrency(invoice.total)}</td>

      <td>
        <span className={`status-pill status-${invoice.xero_status}`}>
          {paymentLabel}
        </span>
      </td>

      <td className="text-center">
        {isApproved && (
          <button
            className="btn btn-link p-0 text-primary"
            onClick={() => handleDownloadInvoice(invoice)}
            title="Download Invoice"
            style={{ fontSize: "18px", lineHeight: 1 }}
            disabled={downloadingInvoiceId === invoiceId}
          >
            {downloadingInvoiceId === invoiceId ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <i className="bi bi-download"></i>
            )}
          </button>
        )}
      </td>

      <td className="text-center">
        <Dropdown align="end">
          <Dropdown.Toggle
            as="button"
            className="actions-btn p-0"
            id={`actions-${invoiceId}`}
            disabled={deleteLoading}
          >
            ⋮
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleViewInvoice(invoice)}>
              View Invoice
            </Dropdown.Item>

            {canEditOrDelete && (
              <Dropdown.Item onClick={() => handleEditInvoice(invoice)}>
                Update Invoice
              </Dropdown.Item>
            )}

            {canEditOrDelete && (
              <Dropdown.Item
                onClick={() => handleDeleteInvoice(invoice)}
                className="text-danger"
                disabled={deleteLoading}
              >
                {deleteLoading ? "Deleting..." : "Remove Invoice"}
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );
};

export default InvoiceRow;
